import { createAuthClient } from "better-auth/react";
import { emailOTPClient, organizationClient } from "better-auth/client/plugins";

export const authClient = createAuthClient({
  baseURL: import.meta.env.VITE_API_URL,
  plugins: [emailOTPClient(), organizationClient()],
  // better-auth captures `fetch` at creation; resolve it per call instead so
  // the dev-only backend mock (src/dev/mock), installed after this module
  // evaluates, sees auth calls too. Identical behavior in production.
  fetchOptions: { customFetchImpl: (input, init) => window.fetch(input, init) },
});

export const { useSession, signOut, getSession } = authClient;
